export function convertPercentageToNumber(percentage: string) {
  const valueWithoutSymbol = percentage.slice(0, percentage.length - 1)
  const result = Number.parseFloat(valueWithoutSymbol) / 100

  return result
}

export function convertLineHeight(fontSize: number, lineHeight: string) {
  const formattedLineHeight = convertPercentageToNumber(lineHeight)
  return fontSize * formattedLineHeight
}
